import * as _ from "lodash";
import {AbstractProperty} from "./AbstractProperty";
import {Node} from "../Node";

export class PBoolean extends AbstractProperty<boolean, Node> {

    default: boolean;

    constructor(args) {
        super({
            type: 'Boolean',
            ...args,
            default: args.default == true || args.default == "true",
        });
    }

    typeCheck(value: boolean): boolean {
        return _.isBoolean(value);
    }

}
